import { render } from "./SummaryValue.vue?vue&type=template&id=622a95a9"
import script from "./SummaryValue.vue?vue&type=script&lang=js"
export * from "./SummaryValue.vue?vue&type=script&lang=js"

import "./SummaryValue.vue?vue&type=style&index=0&id=622a95a9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__